import { Outlet } from "react-router-dom";
import { ChatControllerProvider } from "@/components/chat-widget/chat-controller";
import { WorkbenchProvider } from "@/components/layout/workbench";

/** Single chat + workbench provider for all authenticated practice routes. */
export function ChatControllerLayout() {
  return (
    <ChatControllerProvider>
      <WorkbenchProvider>
        <Outlet />
      </WorkbenchProvider>
    </ChatControllerProvider>
  );
}
